<div class="align-items-center justify-content-right mt-3">
    <button type="button"
            class="btn btn-primary btn-fill ml-3"
            (click)="generatePdf()"
            [attr.disabled]="isLoadingPdf ? 'disabled' : null">
        <i class="fa"
            [ngClass]="{'fa-file-pdf-o': !isLoadingPdf,
                        'fa-spinner fa-spin': isLoadingPdf}"></i> {{ 'VISITORS_MEDICAL.PDF_TREATMENTS' | translate }}
    </button>
</div>